<template>
  <v-dialog v-model="showButtonDialog" persistent width="1100">
    <v-card>
      <v-form ref="htmlTableButtonForm">
        <v-row style="display: block; padding-top: 10px;" v-if="showButtonTemplate">
          <v-alert class="mr-6 ml-6" v-if="errorMessages.length !== 0" dense outlined type="error">
            <li
              v-for="(error, index) in errorMessages"
              :key="index"
              class="caption"
            >
              {{ error }}
            </li>
          </v-alert>
          <ButtonTemplate class="py-2" :is-editing="isEditing" @set-template="setTemplateData" @close-template='closeTemplateDialog' />
        </v-row>
        <v-row class="ma-0" v-if="showButtonForm">
          <v-col lg="6" class="px-0 py-3">
            <v-banner class="pa-0" shaped :sticky="true" style="top: 20px">
              <ButtonItemFormPreview :itemableAttributes="buttonData.itemableAttributes" @open-template="openTemplateDialog" />
            </v-banner>
          </v-col>
          <v-col lg="6" class="py-3">
              <BaseForm :buttonData="buttonData.itemableAttributes" />
              <DetailForm :buttonData="buttonData.itemableAttributes" />
          </v-col>
        </v-row>
      </v-form>
      <div class="p-postEditor__itemFormBtns pb-6 pr-6">
        <div class="p-postEditor__itemFormBtns">
          <v-btn
            class="ml-2"
            small
            tile
            dark
            color="success"
            @click="insertHtml"
          >
            <span>保存</span>
          </v-btn>
          <v-btn
            class="ml-2"
            small
            tile
            dark
            color="yellow darken-2"
            @click="closeDialog"
          >
            <span>キャンセル</span>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import ButtonTemplate from '../../ButtonItem/ButtonTemplate.vue'
import ButtonItemFormPreview from '../../ButtonItem/ButtonItemFormPreview'
import BaseForm from './BaseForm'
import DetailForm from './DetailForm'

export default ({
  name: 'ButtonDialog',
  components: {
    ButtonTemplate,
    ButtonItemFormPreview,
    BaseForm,
    DetailForm
  },
  data: () => {
    return {
      showButtonTemplate: true,
      showButtonForm: false,
      buttonData: null,
      isEditing: false,
      errorMessages: [],
      valid: true
    }
  },
  props: {
    showButtonDialog: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    validateForm () {
      this.valid = this.$refs.htmlTableButtonForm.validate()
    },
    insertHtml () {
      this.validateForm()
      if (!this.valid) return false

      if (this.buttonData) {
        this.$emit('insert-html', this.buttonData.itemableAttributes)
        this.showButtonForm = false
        this.showButtonTemplate = true
        this.isEditing = false
        this.buttonData = null
      } else {
        this.errorMessages.push('必ずボタンテンプレートを選択してください')
        return false
      }
    },
    setTemplateData (templateData) {
      this.buttonData = {
        itemableAttributes: templateData,
        variety: 'html_table'
      }
      this.closeTemplateDialog()
      this.isEditing = true
      this.showButtonForm = true
    },
    openTemplateDialog () {
      this.showButtonForm = false
      this.showButtonTemplate = true
    },
    closeTemplateDialog () {
      this.showButtonTemplate = false
      this.showButtonForm = true
      this.initializeErrorMessage()
    },
    closeDialog () {
      this.$emit('close-button-dialog')
      this.showButtonForm = false
      this.showButtonTemplate = true
      this.buttonData = null
      this.isEditing = false
      this.initializeErrorMessage()
    },
    initializeErrorMessage () {
      this.errorMessages = []
    }
  }
})

</script>
